import React, { useEffect } from 'react';

function DoctoraliaWidget() {
  useEffect(() => {
    if (!document.getElementById('zl-widget-s')) {
      const script = document.createElement('script');
      script.id = 'zl-widget-s';
      script.src = '//platform.docplanner.com/js/widget.js';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <a
      id="zl-url"
      className="zl-url"
      href="https://www.doctoralia.com.br/lara-helena-de-souza-frasson/psicologo/curitiba"
      rel="nofollow"
      data-zlw-doctor="lara-helena-de-souza-frasson"
      data-zlw-type="big_with_calendar"
      data-zlw-opinion="false"
      data-zlw-hide-branding="true"
      data-zlw-saas-only="false"
      data-zlw-a11y-title="Widget de marcação de consultas médicas"
      target="_blank"
      style={{ width: '100%' }}
    >
      Lara Helena De Souza Frasson - Doctoralia.com.br
    </a>
  );
};

export default DoctoraliaWidget;
